import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { TranslateModule } from '@ngx-translate/core'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import { GbPresenterToolsTextComponent } from '../gb-presenter-tools-text/gb-presenter-tools-text.component'
import { BORDER_STYLE_OPTIONS, TEXT_DECORATION_OPTIONS } from '../presenter-tools-options'

@Component({
  selector: 'gb-presenter-tools-text-widget',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    TranslateModule,
    GbDashboardSharedUiModule,
    GbPresenterToolsTextComponent,
  ],
  templateUrl: './gb-presenter-tools-text-widget.component.html',
  styleUrl: './gb-presenter-tools-text-widget.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterToolsTextWidgetComponent {
  @Input({ required: true }) toolsFormGroup!: FormGroup

  textDecorationOptions = TEXT_DECORATION_OPTIONS
  borderStyleOptions = BORDER_STYLE_OPTIONS

  get textControl(): FormControl {
    return this.toolsFormGroup.get('text') as FormControl
  }

  get textDecorationControl(): FormControl {
    return this.toolsFormGroup.get('text_decoration') as FormControl
  }

  get lineHeightControl(): FormControl {
    return this.toolsFormGroup.get('line_height') as FormControl
  }

  get letterSpacingControl(): FormControl {
    return this.toolsFormGroup.get('letter_spacing') as FormControl
  }

  get borderWidthControl(): FormControl {
    return this.toolsFormGroup.get('border_width') as FormControl
  }

  get borderColorControl(): FormControl {
    return this.toolsFormGroup.get('border_color') as FormControl
  }

  get borderStyleControl(): FormControl {
    return this.toolsFormGroup.get('border_style') as FormControl
  }
}
